import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import { mostrarMensajeDeErrorConToast, responseCode200, responseTieneModelState } from "../../../consumers/httpRequiestsUtils";
import { GENERIC_SUCCESS_TOAST_MESSAGE, TIPO_PRESTAMO_IDS_MOTIVO, TIPO_PRESTAMO_IDS_CUOTAS, TIPO_PRESTAMO_IDS_MESGRATI, TIPO_PRESTAMO_IDS_SIN_SUSTENTO, ID_SOLICITUD_TIPO_PRESTAMO, ID_SOLICITUD_TIPO_ADELANTO_SUELDO } from "../../../constants/hardCodedConstants";

import GenericModal from '../../../components/modal/GenericModal';
import SelectInput from "../../../components/Select/SelectInput";
import SpinnerLoading from '../../../components/pageComponents/SpinnerLoading';
import GenericUploadFileV2 from "../../../components/GenericUploadFile/GenericUploadFileV2";
import { useGetRequest } from "../../../hooks/useGetRequest/useGetRequest";
import { usePostRequest } from "../../../hooks/usePostRequest/usePostRequest";
import { isEmpty, mapDropDownOptionsFromBackendToSelectOptionsNeededForLibraryGeneric, formatearMesPreview, calcularMesFinPreview } from "../../../helper/utils";
import { getAllTipoSolicitudPrestamoAPI, getAllTipoMotivosPrestamoAPI, getDetalleSolicitudPrestamoAPI, editarSolicitudPrestamoAPI, getMaxCuotaPrestamoAPI, getMiSueldoAPI, getSueldoColaboradorAPI } from "../../../consumers/backendApisUrls";
import { AlertErrorMaxFileSizePrestamos } from "../alerts/AlertErrorMaxFileSizePrestamos";
import InputBool from '../../../components/modalComponents/InputBool';

const EditarPrestamo = ({ idPrestamo, showModal, refreshPage, fromAdminPage = false, fechaIngreso = "", esGestorPrestamos = false }) => {
    const sectionName = "EditarPrestamoModal";
// esGestorPrestamos={rolGestionDePrestamos}
    const [isLoading, setIsLoading]   = useState(true);
    const [enviando, setEnviando]     = useState(false);
    const [formValues, setFormValues] = useState({});

    // Catálogos
    const [tiposDePrestamoFiltradosOptions, setTiposDePrestamoFiltradosOptions]   = useState([]);
    const [motivosDePrestamoFiltradosOptions, setMotivosDePrestamoFiltradosOptions] = useState([]);

    // Selects
    const [jsonSelectedTiposPrestamoValue,  setJsonSelectedTiposPrestamoValue]  = useState({});
    const [jsonSelectedMotivoPrestamoValue, setJsonSelectedMotivoPrestamoValue] = useState({});
    const [jsonTextAreaOtros, setJsonTextAreaOtros] = useState("");

    // Archivo
    const [s3UploadFileResponse, setS3UploadFileResponse] = useState({});
    const [subiendoArchivo, setSubiendoArchivo]           = useState(false);
    const [archivoActual, setArchivoActual] = useState({ url: null, nombre: null });
    const [s3UploadFileResponseSustento, setS3UploadFileResponseSustento] = useState({});
    const [subiendoArchivoSustento, setSubiendoArchivoSustento]           = useState(false);
    const [archivoSustentoActual, setArchivoSustentoActual] = useState({ url: null, nombre: null });
    const [detalleInfo, setDetalleInfo] = useState({});
    const esModoObservado =
        Number(detalleInfo.IdEstadoProceso) === 13 &&
        !(fromAdminPage && esGestorPrestamos);
    const UPDATE_FILE_ID = "editarPrestamoModal-archivo";
    const UPDATE_FILE_SUSTENTO_ID = "editarPrestamoModal-sustento";

    // const [s3UploadFileResponseFirma, setS3UploadFileResponseFirma] = useState({});
    // const [subiendoArchivoFirma, setSubiendoArchivoFirma] = useState(false);
    // const UPDATE_FILE_FIRMA_ID = "addPrestamoModal-firma";

    const [executeGetRequest]  = useGetRequest();
    const [executePostRequest] = usePostRequest();
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [maxCuota, setMaxCuota] = useState(10);
    const [mesGratificacionPermitido, setMesGratificacionPermitido] = useState("");
    const [sueldoEmpleado, setSueldoEmpleado] = useState("");
    const [editMesFinPreview, setEditMesFinPreview] = useState(null);



    useEffect(() => {
        init();
    }, []);

    // Limpiar motivo al cambiar tipo
    useEffect(() => {
        if (isInitialLoad) return;
        setJsonSelectedMotivoPrestamoValue({});
        setJsonTextAreaOtros("");
        setFormValues(prev => ({ ...prev, NroCuotas: "", MesDsctoGratificacion: "" }));
    }, [jsonSelectedTiposPrestamoValue]);

    useEffect(() => {
        const tipo = jsonSelectedTiposPrestamoValue?.Value;
        if (TIPO_PRESTAMO_IDS_MESGRATI.includes(Number(tipo))) {
            setMesGratificacionPermitido(detalleInfo?.MesDsctoGratificacion || "");
        } else {
            setMesGratificacionPermitido("");
        }
    }, [jsonSelectedTiposPrestamoValue, detalleInfo]);

    useEffect(() => {
        if (mesGratificacionPermitido) {
            setFormValues(prev => ({ ...prev, MesDsctoGratificacion: mesGratificacionPermitido }));
        }
    }, [mesGratificacionPermitido]);

    useEffect(() => {
        const inicio = detalleInfo.MesInicioDescuento || formValues.MesInicioDescuento;
        const cuotasStr = formValues.NroCuotas;
        if (inicio && cuotasStr && parseInt(cuotasStr) > 0) {
            setEditMesFinPreview(calcularMesFinPreview(inicio, parseInt(cuotasStr)));
        } else {
            setEditMesFinPreview(null);
        }
    }, [formValues.NroCuotas, detalleInfo.MesInicioDescuento]);

    const init = async () => {
        
        setIsLoading(true);
        try {
            // 1. Cargar catálogos en paralelo
            const [responseTipos, responseMotivos, responseDetalle, responseMaxCuota] = await Promise.all([
                executeGetRequest(getAllTipoSolicitudPrestamoAPI()),
                executeGetRequest(getAllTipoMotivosPrestamoAPI()),
                executeGetRequest(getDetalleSolicitudPrestamoAPI(idPrestamo)),
                executeGetRequest(getMaxCuotaPrestamoAPI()),
            ]);

            if (responseCode200(responseMaxCuota)) {
                setMaxCuota(responseMaxCuota.data.CuotaMaxima);
            }

            // Cargar sueldo después de detalle
            if (responseCode200(responseDetalle)) {
                const detalle = responseDetalle.data;
                if (fromAdminPage && detalle.IdEmpleado) {
                    let resp = await executeGetRequest(getSueldoColaboradorAPI(detalle.IdEmpleado));
                    if (responseCode200(resp) && resp.data) {
                        setSueldoEmpleado(resp.data);
                    }
                } else if (!fromAdminPage) {
                    let resp = await executeGetRequest(getMiSueldoAPI());
                    if (responseCode200(resp) && resp.data) {
                        setSueldoEmpleado(resp.data);
                    }
                }
            }

            // 2. Tipos de solicitud
            if (responseCode200(responseTipos)) {
                const options = mapDropDownOptionsFromBackendToSelectOptionsNeededForLibraryGeneric(
                    responseTipos.data, "Value", "Text");
                setTiposDePrestamoFiltradosOptions(options);

                // Preseleccionar tipo actual
                if (responseCode200(responseDetalle)) {
                    const detalle = responseDetalle.data;
                    console.log("detalle.IdTipoSolicitud:", detalle.IdTipoSolicitud, typeof detalle.IdTipoSolicitud);
                    const tipoActual = options.find(o => o.Value === detalle.IdTipoSolicitud);
                    console.log("tipoActual encontrado:", tipoActual);
                    if (tipoActual) setJsonSelectedTiposPrestamoValue(tipoActual);
                }
            } else {
                mostrarMensajeDeErrorConToast(responseTipos);
            }

            // 3. Motivos
            if (responseCode200(responseMotivos)) {
                const options = mapDropDownOptionsFromBackendToSelectOptionsNeededForLibraryGeneric(
                    responseMotivos.data, "Value", "Text");
                setMotivosDePrestamoFiltradosOptions(options);

                // Preseleccionar motivo actual
                if (responseCode200(responseDetalle) && responseDetalle.data.IdMotivo) {
                    const motivoActual = options.find(o => o.Value === responseDetalle.data.IdMotivo);
                    if (motivoActual) setJsonSelectedMotivoPrestamoValue(motivoActual);
                }
            } else {
                mostrarMensajeDeErrorConToast(responseMotivos);
            }

            // 4. Precargar datos del formulario
            if (responseCode200(responseDetalle)) {
                const detalle = responseDetalle.data;
                setDetalleInfo(detalle);
                if (detalle.ArchivoUrl) {
                    setArchivoActual({ url: detalle.ArchivoUrl, nombre: detalle.ArchivoNombre });
                }
                if (detalle.ArchivoSustentoUrl) {
                    setArchivoSustentoActual({ url: detalle.ArchivoSustentoUrl, nombre: detalle.ArchivoSustentoNombre });
                }
                setFormValues({
                    IdTipoSolicitud:        detalle.IdTipoSolicitud,
                    Monto:                  detalle.Monto,
                    NroCuotas:              detalle.NroCuotas > 0 ? String(detalle.NroCuotas) : "",
                    MesDsctoGratificacion:  detalle.MesDsctoGratificacion || "",
                    IdMotivoSolicitud:      detalle.IdMotivo,
                    OtroMotivo:             "",
                    EnviadoAPlanilla:       detalle.EnviadoAPlanilla ?? false,
                    TieneExcepcion:         detalle.TieneExcepcion ?? false,
                    MotivoExcepcion:        detalle.MotivoExcepcion ?? "",
                });
                // Si el motivo era "Otro" cargar el texto
                if (detalle.OtroMotivo) setJsonTextAreaOtros(detalle.OtroMotivo);
            } else {
                mostrarMensajeDeErrorConToast(responseDetalle);
            }
            setIsInitialLoad(false);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

        
    };

    const tipoSolicitudActual = jsonSelectedTiposPrestamoValue?.Value;
    console.log("tipo:", tipoSolicitudActual, typeof tipoSolicitudActual);
    console.log("includes:", TIPO_PRESTAMO_IDS_CUOTAS.includes(tipoSolicitudActual));
    console.log("options:", tiposDePrestamoFiltradosOptions);
    console.log("selected:", jsonSelectedTiposPrestamoValue);

    const handleGuardar = async () => {
        // ── Validaciones ───────────────────────────────────────────
        if (!esModoObservado) {
            if (!jsonSelectedTiposPrestamoValue?.Value) {
                toast.warn("Debe seleccionar un tipo de solicitud.");
                return;
            }
            if (isEmpty(String(formValues.Monto ?? ""))) {
                toast.warn("Debe ingresar un monto.");
                return;
            }
            if (tipoSolicitudActual === ID_SOLICITUD_TIPO_PRESTAMO &&
                isEmpty(formValues.NroCuotas)) {
                toast.warn("Debe seleccionar el número de cuotas.");
                return;
            }
            if (TIPO_PRESTAMO_IDS_MOTIVO.includes(Number(tipoSolicitudActual))) {
                if (!jsonSelectedMotivoPrestamoValue?.Value) {
                    toast.warn("Debe seleccionar un motivo.");
                    return;
                }
                const labelMotivo = jsonSelectedMotivoPrestamoValue?.label;
                if ((labelMotivo === "Otros" || labelMotivo === "Otro") && isEmpty(jsonTextAreaOtros)) {
                    toast.warn("Debe especificar el motivo en el campo de texto.");
                    return;
                }
            }
            if (TIPO_PRESTAMO_IDS_MESGRATI.includes(Number(tipoSolicitudActual)) &&
                isEmpty(formValues.MesDsctoGratificacion)) {
                toast.warn("Debe seleccionar el mes de gratificación.");
                return;
            }
            if (formValues.TieneExcepcion && isEmpty(formValues.MotivoExcepcion)) {
                toast.warn("Debe ingresar el detalle de la excepción.");
                return;
            }
        }

        // ── Payload ────────────────────────────────────────────────
        const payload = esModoObservado
            ? {
                IdPrestamo:             idPrestamo,
                ModoRegistro:           fromAdminPage ? "REGISTRO_ADMIN" : "REGISTRO_USUARIO",
                FileViewModelSustento:  s3UploadFileResponseSustento?.Path ? s3UploadFileResponseSustento : null,
              }
            : {
                IdPrestamo:             idPrestamo,
                ModoRegistro:           fromAdminPage ? "REGISTRO_ADMIN" : "REGISTRO_USUARIO", 
                IdTipoSolicitud:        jsonSelectedTiposPrestamoValue?.Value,
                Monto:                  formValues.Monto,
                NroCuotas:              formValues.NroCuotas || null,
                IdMotivoSolicitud:      jsonSelectedMotivoPrestamoValue?.Value || null,
                OtroMotivo:             jsonTextAreaOtros || null,
                MesDsctoGratificacion:  formValues.MesDsctoGratificacion || null,
                FileViewModel:          s3UploadFileResponse?.Path ? s3UploadFileResponse : null,
                FileViewModelSustento:  s3UploadFileResponseSustento?.Path ? s3UploadFileResponseSustento : null,
                EnviadoAPlanilla:       formValues.EnviadoAPlanilla ?? false,
                TieneExcepcion:         formValues.TieneExcepcion ?? false,
                MotivoExcepcion:        formValues.TieneExcepcion ? formValues.MotivoExcepcion : null,
              };

        setEnviando(true);
        try {
            const response = await executePostRequest(editarSolicitudPrestamoAPI(), payload);
            if (responseCode200(response)) {
                showModal();
                toast.success(response?.data?.Message || GENERIC_SUCCESS_TOAST_MESSAGE);
                await refreshPage();
            } else if (responseTieneModelState(response)) {
                console.log("responseTieneModelState");
            } else {
                mostrarMensajeDeErrorConToast(response);
            }
        } finally {
            setEnviando(false);
        }
    };

    if (isLoading) return <SpinnerLoading />;


    
    

    return (
        <GenericModal titulo="Editar Solicitud de Préstamo/Adelanto" showModal={showModal} width='900px'>
            <div className="modal-body">
                <form className="black-color-important">
                    <div className="displayFlexWrap">

                        {/* ── Información de contexto (solo lectura) ── */}
                        <div className="form-row" style={{ width: "100%", margin: "0 0 16px 0", paddingBottom: "16px", borderBottom: "1px solid #dee2e6" }}>
                            <div className="form-group col-sm-6">
                                <label className="modal-label mb-0">Colaborador</label>
                                <input type="text" className="form-control" value={detalleInfo.Colaborador ?? ""} disabled />
                            </div>
                            <div className="form-group col-sm-6">
                                <label className="modal-label mb-0">Correo</label>
                                <input type="text" className="form-control" value={detalleInfo.CorreoCorporativo ?? ""} disabled />
                            </div>

                            <div className="form-group col-sm-6">
                                <label className="modal-label mb-0">Sede</label>
                                <input type="text" className="form-control" value={detalleInfo.Sede ?? ""} disabled />
                            </div>
                            <div className="form-group col-sm-6">
                                <label className="modal-label mb-0">Cargo</label>
                                <input type="text" className="form-control" value={detalleInfo.Cargo ?? ""} disabled />
                            </div>

                            <div className="form-group col-sm-6">
                                <label className="modal-label mb-0">Fecha Ingreso Colaborador</label>
                                <input type="text" className="form-control" value={fechaIngreso ?? ""} disabled />
                            </div>
                            <div className="form-group col-sm-6">
                                <label className="modal-label mb-0">Fecha Registro</label>
                                <input type="text" className="form-control" value={detalleInfo.FechaRegistro ?? ""} disabled />
                            </div>

                            <div className="form-group col-sm-6">
                                <label className="modal-label mb-0">Estado</label>
                                <input type="text" className="form-control" value={detalleInfo.EstadoProceso ?? ""} disabled />
                            </div>
                                                    
                            {Number(detalleInfo.IdEstadoProceso) === 13 && detalleInfo.MotivoObservacion && (
                                <div className="form-group col-sm-12">
                                    <label className="modal-label mb-0">Motivo de Observación</label>
                                    <textarea className="form-control" rows={2}
                                        value={detalleInfo.MotivoObservacion}
                                        disabled />
                                </div>
                            )}
                            {sueldoEmpleado && (
                            <div className="form-group col-sm-6">
                                <label className="modal-label mb-0">Sueldo del Colaborador</label>
                                <input type="text" className="form-control"
                                    value={`S/. ${parseFloat(sueldoEmpleado).toFixed(2)}`} disabled />
                            </div>
                            )}
                            {fromAdminPage && detalleInfo.NombreApruebaNivel2 && (
                            <div className="form-group col-sm-6">
                                <label className="modal-label mb-0">Aprobado Nivel 2</label>
                                <input type="text" className="form-control"
                                    value={detalleInfo.NombreApruebaNivel2} disabled />
                            </div>
                            )}
                            {fromAdminPage && detalleInfo.FechaApruebaNivel2 && (
                            <div className="form-group col-sm-6">
                                <label className="modal-label mb-0">Fecha Aprobación N2</label>
                                <input type="text" className="form-control"
                                    value={detalleInfo.FechaApruebaNivel2} disabled />
                            </div>
                            )}
                            {fromAdminPage && detalleInfo.ComentarioApruebaNivel2 && (
                            <div className="form-group col-sm-12">
                                <label className="modal-label mb-0">Comentario de Aprobación N2</label>
                                <textarea className="form-control" rows={2}
                                    value={detalleInfo.ComentarioApruebaNivel2} disabled />
                            </div>
                            )}
                            {detalleInfo.MesInicioDescuento && (
                            <div className="form-group col-sm-6">
                                <label className="modal-label mb-0">Mes Inicio Descuento</label>
                                <input type="text" className="form-control"
                                    value={formatearMesPreview(detalleInfo.MesInicioDescuento)} disabled />
                            </div>
                            )}
                            {(detalleInfo.MesFinDescuento || editMesFinPreview) ? (
                            <div className="form-group col-sm-6">
                                <label className="modal-label mb-0">Mes Fin Descuento</label>
                                <input type="text" className="form-control"
                                    value={formatearMesPreview(editMesFinPreview || detalleInfo.MesFinDescuento)} disabled />
                            </div>
                            ) : null}
                        </div>

                        {fromAdminPage && (
                        <>
                        <div className="col-sm-12 col-md-6 mb-3">                                
                                <InputBool
                                    label="Enviado a Planilla"
                                    name="EnviadoAPlanilla"
                                    value={formValues.EnviadoAPlanilla ?? false}
                                    onChange={e => setFormValues(prev => ({
                                        ...prev,
                                        EnviadoAPlanilla: e?.target?.checked ?? false
                                    }))}
                                    sectionName={sectionName}
                                    isDisabled={!esGestorPrestamos}
                                />                                
                        </div>
                        <div className="col-sm-12 col-md-6 mb-3">
                                <InputBool
                                    label="Excepción"
                                    name="TieneExcepcion"
                                    value={formValues.TieneExcepcion ?? false}
                                    onChange={e => {
                                        const checked = e?.target?.checked ?? false;
                                        setFormValues(prev => ({
                                            ...prev,
                                            TieneExcepcion: checked,
                                            MotivoExcepcion: checked ? prev.MotivoExcepcion : ""
                                        }));
                                    }}
                                    sectionName={sectionName}
                                    isDisabled={!esGestorPrestamos}
                                />
                        </div>
                        {formValues.TieneExcepcion && (
                        <div className="col-sm-12 mb-3">
                            <label className="modal-label">
                                Detalle de la Excepción <span className="required">*</span>
                            </label>
                            <textarea className="form-control" rows={3}
                                disabled={!esGestorPrestamos}
                                value={formValues.MotivoExcepcion ?? ""}
                                onChange={e => {
                                    const value = e.target.value;
                                    setFormValues(prev => ({
                                        ...prev,
                                        MotivoExcepcion: value
                                    }));
                                }}
                                placeholder="Describa el detalle de la excepción..." />
                        </div>
                        )}
                        </>
                        )}
                            

                        {/* ── Tipo de Solicitud ── */}
                        <div className="col-sm-12 col-md-6 mb-3">
                            <label className="modal-label">
                                Tipo de Solicitud <span className="required">*</span>
                            </label>
                            <SelectInput
                                options={tiposDePrestamoFiltradosOptions}
                                jsonSelectedValue={jsonSelectedTiposPrestamoValue}
                                setJsonSelectedValue={(seleccionado) => {
                                    if (!isInitialLoad && seleccionado?.Value !== jsonSelectedTiposPrestamoValue?.Value) {
                                        setJsonSelectedMotivoPrestamoValue({});
                                        setJsonTextAreaOtros("");
                                        setFormValues(prev => ({
                                            ...prev,
                                            NroCuotas: "",
                                            MesDsctoGratificacion: "",
                                            IdTipoSolicitud: seleccionado?.Value || null
                                        }));
                                    }else{
                                        setFormValues(prev => ({
                                                        ...prev,
                                                        IdTipoSolicitud: seleccionado?.Value || null
                                                    }));
                                    }
                                    setJsonSelectedTiposPrestamoValue(seleccionado);
                                    setFormValues(prev => ({
                                        ...prev,
                                        IdTipoSolicitud: seleccionado?.Value || null
                                    }));
                                }}
                                isDisabled={esModoObservado}
                                resetSelectedValue={false}
                                placeholder="Seleccionar tipo de solicitud" />
                                {Number(tipoSolicitudActual) === ID_SOLICITUD_TIPO_ADELANTO_SUELDO && (
                                    <small className="text-danger">
                                        El adelanto se descontará del pago de haberes del mes donde se aprueba la solicitud.
                                    </small>
                                )}
                        </div>

                        {/* ── Monto ── */}
                        <div className="col-sm-12 col-md-6 mb-3">
                            <label className="modal-label">
                                Monto (S/.) <span className="required">*</span>
                            </label>
                            <input
                                type="number" step="0.01" min="0"
                                className="form-control" placeholder="0.00"
                                disabled={esModoObservado}
                                value={formValues.Monto ?? ""}
                                onChange={e => setFormValues({ ...formValues, Monto: e.target.value })}
                            />
                        </div>

                        {/* ── Número de Cuotas ── */}
                        {TIPO_PRESTAMO_IDS_CUOTAS.includes(tipoSolicitudActual) && (
                        <div className="col-sm-12 mb-3">
                            <label className="modal-label">
                                Número de Cuotas <span className="required">*</span>
                            </label>
                            <select className="form-control col-sm-6"
                                disabled={esModoObservado}
                                value={formValues.NroCuotas ?? ""}
                                onChange={e => setFormValues({ ...formValues, NroCuotas: e.target.value })}>
                                <option value="" disabled>Seleccione...</option>
                                {Array.from({ length: maxCuota }, (_, i) => i + 1).map(n => (
                                    <option key={n} value={n}>{n}</option>
                                ))}
                            </select>
                            {parseFloat(formValues.Monto) > 0 && parseInt(formValues.NroCuotas) > 0 && (
                            <div className="mt-2">
                                <span className="text-muted">
                                    Valor de Cuota: S/. {(parseFloat(formValues.Monto) / parseInt(formValues.NroCuotas)).toFixed(2)}
                                </span>
                            </div>
                            )}
                        </div>
                        )}

                        {/* ── Mes de Descuento de Gratificación ── */}
                        {TIPO_PRESTAMO_IDS_MESGRATI.includes(tipoSolicitudActual) ? (
                        mesGratificacionPermitido ? (
                        <div className="col-sm-12 mb-3">
                            <label className="modal-label">
                                Mes de Descuento de Gratificación <span className="required">*</span>
                            </label>
                            <input type="text" className="form-control col-sm-6"
                                value={mesGratificacionPermitido} disabled />
                        </div>
                        ) : (
                        <div className="col-sm-12 mb-3">
                            <label className="modal-label">
                                Mes de Descuento de Gratificación <span className="required">*</span>
                            </label>
                            <select className="form-control col-sm-6"
                                disabled={esModoObservado}
                                value={formValues.MesDsctoGratificacion ?? ""}
                                onChange={e => setFormValues({ ...formValues, MesDsctoGratificacion: e.target.value })}>
                                <option value="" disabled>Seleccione...</option>
                                <option value="Julio">Julio</option>
                                <option value="Diciembre">Diciembre</option>
                            </select>
                        </div>
                        )
                        ) : null}

                        {/* ── Motivo ── */}
                        {TIPO_PRESTAMO_IDS_MOTIVO.includes(tipoSolicitudActual) && (
                        <>
                        <div className="col-sm-12 col-md-6 mb-3">
                            <label className="modal-label">
                                Motivo <span className="required">*</span>
                            </label>
                            <SelectInput
                                options={motivosDePrestamoFiltradosOptions}
                                jsonSelectedValue={jsonSelectedMotivoPrestamoValue}
                                setJsonSelectedValue={(seleccionado) => {
                                    setJsonSelectedMotivoPrestamoValue(seleccionado);
                                    setFormValues(prev => ({
                                        ...prev,
                                        IdMotivoSolicitud: seleccionado?.Value || null
                                    }));
                                }}
                                isDisabled={esModoObservado}
                                resetSelectedValue={false}
                                placeholder="Seleccionar motivo" />
                        </div>
                        {(jsonSelectedMotivoPrestamoValue?.label === "Otros" ||
                          jsonSelectedMotivoPrestamoValue?.label === "Otro") && (
                        <div className="col-sm-12 col-md-6 mb-3">
                            <textarea className="form-control" rows={3}
                                disabled={esModoObservado}
                                onChange={e => {
                                    setJsonTextAreaOtros(e.target.value);
                                    setFormValues(prev => ({ ...prev, OtroMotivo: e.target.value }));
                                }}
                                value={jsonTextAreaOtros ?? ""}
                                placeholder="Describa el motivo..."
                            />
                        </div>
                        )}
                        </>
                        )}

                        {/* ── Archivos Adjuntos ── */}
                        {fromAdminPage ? (
                        <div className="col-sm-12 mb-3">
                            {archivoActual.url && (
                                <div className="mb-3">
                                    <label className="modal-label">Documento de Autorización</label>
                                    <div>
                                        <a href={archivoActual.url}
                                           target="_blank"
                                           rel="noopener noreferrer"
                                           className="blue-standard-color">
                                            <FontAwesomeIcon icon="file" className="mr-1" />
                                            {archivoActual.nombre || "Ver archivo"}
                                        </a>
                                    </div>
                                </div>
                            )}
                            {!TIPO_PRESTAMO_IDS_SIN_SUSTENTO.includes(tipoSolicitudActual) && archivoSustentoActual.url && (
                                <div className="mb-3">
                                    <label className="modal-label">Documento Sustento</label>
                                    <div>
                                        <a href={archivoSustentoActual.url}
                                           target="_blank"
                                           rel="noopener noreferrer"
                                           className="blue-standard-color">
                                            <FontAwesomeIcon icon="file" className="mr-1" />
                                            {archivoSustentoActual.nombre || "Ver archivo"}
                                        </a>
                                    </div>
                                </div>
                            )}
                            {!archivoActual.url && !archivoSustentoActual.url && (
                                <p className="text-muted">No hay archivos adjuntos.</p>
                            )}
                        </div>
                        ) : (
                        <>
                        {!esModoObservado && (
                        <div className="col-sm-12 mb-3">
                            {archivoActual.url && (
                                <div className="mb-3">
                                    <label className="modal-label">PDF firmado actual</label>
                                    <div>
                                        <a href={archivoActual.url}
                                           target="_blank"
                                           rel="noopener noreferrer"
                                           className="blue-standard-color">
                                            <FontAwesomeIcon icon="file" className="mr-1" />
                                            {archivoActual.nombre || "Ver archivo"}
                                        </a>
                                    </div>
                                </div>
                            )}
                            <label className="modal-label">
                                Imagen de Firma
                                <small className="text-muted ml-2">(opcional — solo si desea reemplazar la firma)</small>
                            </label>
                            <div className="d-flex align-items-center">
                                <GenericUploadFileV2
                                    uploadFileToS3={setS3UploadFileResponse}
                                    id={UPDATE_FILE_ID}
                                    textButton="Subir imagen de tu firma"
                                    extensionesValidas={["jpg", "jpeg", "png"]}
                                    ToastArchivoNoValido={AlertErrorMaxFileSizePrestamos}
                                    subiendoArchivoPublicState={subiendoArchivo}
                                    setSubiendoArchivoPublicState={setSubiendoArchivo}
                                    resetInitialFile={false}
                                />
                                <p className="ficha-form-input-validation-message"
                                   id={`ficha-edit-${sectionName}-FileViewModel-validation-message`}></p>
                            </div>
                            <small className="text-muted">
                                Formatos aceptados: JPG y PNG (máx. 8MB)
                            </small>
                        </div>
                        )}
                        {!TIPO_PRESTAMO_IDS_SIN_SUSTENTO.includes(tipoSolicitudActual) && (
                        <div className="col-sm-12 mb-3">
                            {archivoSustentoActual.url && (
                                <div className="mb-3">
                                    <label className="modal-label">Documento sustento actual</label>
                                    <div>
                                        <a href={archivoSustentoActual.url}
                                           target="_blank"
                                           rel="noopener noreferrer"
                                           className="blue-standard-color">
                                            <FontAwesomeIcon icon="file" className="mr-1" />
                                            {archivoSustentoActual.nombre || "Ver archivo"}
                                        </a>
                                    </div>
                                </div>
                            )}
                            <label className="modal-label">
                                Documento Sustento
                                <small className="text-muted ml-2">(opcional — solo si desea reemplazar el actual)</small>
                            </label>
                            <div className="d-flex align-items-center">
                                <GenericUploadFileV2
                                    uploadFileToS3={setS3UploadFileResponseSustento}
                                    id={UPDATE_FILE_SUSTENTO_ID}
                                    textButton="Subir documento sustento"
                                    extensionesValidas={["pdf", "jpg", "jpeg", "png"]}
                                    ToastArchivoNoValido={AlertErrorMaxFileSizePrestamos}
                                    subiendoArchivoPublicState={subiendoArchivoSustento}
                                    setSubiendoArchivoPublicState={setSubiendoArchivoSustento}
                                    resetInitialFile={false}
                                />
                                <p className="ficha-form-input-validation-message"
                                   id={`ficha-edit-${sectionName}-Sustento-validation-message`}></p>
                            </div>
                            <small className="text-muted">
                                Formatos aceptados: PDF, JPG, PNG (máx. 8MB)
                            </small>
                        </div>
                        )}
                        </>
                        )}

                    </div>

                    {/* ── Guardar ── */}
                    <div className="modal-footer pl-0">
                        <div className="d-flex justify-content-end w-100">
                            <button type="button"
                                className="generic-button-buscador"
                                onClick={handleGuardar}
                                disabled={enviando || subiendoArchivo || subiendoArchivoSustento}>
                                {enviando ? "Guardando..." : "Guardar"}
                            </button>
                        </div>
                    </div>

                </form>
            </div>
        </GenericModal>
    );
};

export default EditarPrestamo;
